import type { ShortUser } from '@src/features/users';
import { useFormMethodsContext } from '@src/shared/form';
import { useEffect } from 'react';
import { type Control, type FieldValues, useWatch } from 'react-hook-form';

const ACTIVE_USERS = { is_active: true };

/**
 * The secondary Keller contact of a contact form is another user than its
 * Keller contact (client call 2): the Keller contact is not offered for it,
 * and choosing the secondary one as Keller contact empties it. Returns the
 * filters of the secondary field; the server saves the same user twice as
 * no secondary contact.
 */
export function useSecondaryKellerContact(
  userContactName: string,
  userContact2Name: string,
) {
  const { control, setValue } = useFormMethodsContext() as {
    control: Control<FieldValues>;
    setValue: (
      name: string,
      value: unknown,
      options?: { shouldDirty?: boolean },
    ) => void;
  };
  const [userContact, userContact2] = useWatch({
    control,
    name: [userContactName, userContact2Name],
  }) as [ShortUser | null, ShortUser | null];

  useEffect(() => {
    if (userContact && userContact2?.id === userContact.id) {
      setValue(userContact2Name, null, { shouldDirty: true });
    }
  }, [setValue, userContact, userContact2, userContact2Name]);

  return { ...ACTIVE_USERS, exclude_ids: userContact?.id };
}
